
window.$ = window.jQuery = require('jquery');
const bootstrap = require('bootstrap');

import "../../sass/main.scss"
